import React from 'react';
import CalendarComponent from '../../components/calendarComponent';

export function CalendarPage() {
  return <CalendarComponent/>;
}